import {
  ChangeStatusButton,
  DeleteButton,
  EditButton,
} from "@/components/IconButton/variants";
import { STATUS } from "@/constant/statusConstants";

import PropTypes from "prop-types";
import React from "react";

function Actions({
  row,
  handleOnClickDelete,
  handleOnChangeStatus,
  handleOnClickEdit,
  enableStatus = true,
  enableDelete = true,
  statusColumn = "status",
}) {
  return (
    <div className="w-auto flex gap-x-1 justify-center">
      {enableStatus && (
        <ChangeStatusButton
          isActive={row.original[statusColumn] === STATUS.ACTIVE}
          onClick={() => handleOnChangeStatus(row.original)}
        />
      )}
      <EditButton onClick={() => handleOnClickEdit(row.original)} />
      {enableDelete && (
        <DeleteButton onClick={() => handleOnClickDelete(row.original)} />
      )}
    </div>
  );
}

Actions.propTypes = {
  row: PropTypes.object.isRequired,
  handleOnClickDelete: PropTypes.func.isRequired,
  handleOnChangeStatus: PropTypes.func.isRequired,
  handleOnClickEdit: PropTypes.func.isRequired,
};

export default React.memo(Actions);
